module.exports = __webpack_public_path__ + "img/speaker-8.6322df0f.jpg";